import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Stats from "@/components/site/Stats";
import Inspection from "@/components/site/Inspection";
import Booking from "@/components/site/Booking";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); };
  }, []);

  return (
    <div className="relative bg-[#050505] text-[#F5F5F0] font-body overflow-hidden">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Process />
        <Stats />
        <Inspection />
        <Booking />
        <QuoteForm />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
